export function getMapping() {
  return {
    "disinfection":{
      "01":"高温蒸煮",
      "02":"紫外线",
      "03":"电离辐射",
      "04":"化学剂消毒",
      "05":"机械消毒",
      "06":"红外线消毒"
    },
    "meal":{
      "01":"早餐",
      "02":"午餐",
      "03":"晚餐"
    },
    "check":{
      "0001":"发热",
      "0002":"感冒咳嗽",
      "0003":"外伤",
      "0004":"呕吐腹泻",
      "0005":"皮肤疾病",
      "5000":"其它疾病",
      "5001":"着装不规范",
      "5002":"双手不干净",
      "5003":"指甲过长",
      "5004":"戒指等饰品",
      "9999":"其它卫生问题"
    },
    "food":{
      "01":"主食",
      "02":"荤菜",
      "03":"素菜",
      "04":"配汤",
      "05":"水果",
      "06":"饮品",
      "07":"点心",
      "99":"其他"
    },
    "employee":{
      "01":"负责人",
      "02":"管理人员",
      "03":"从业人员",
      "04":"其他人员",
    },
    "gender":{
      '1':'男',
      '2':'女',
      '3':'未知',
    }
  }

}
